import React from 'react'
import {Swiper, SwiperSlide} from 'swiper/react';
import './Portfolio.css';
import todolist from '../../img/todolist.png';
import amazonclone from '../../img/amazonclone.png';
import blogsite from '../../img/blogsite.png';
import 'swiper/css'


const Portfolio = () => {
  return (
    <div className='portfolio' id='Portfolio'>

        {/* heading */}
        <span>Recent Projects</span>
        <span>Portfolio</span>

        {/* slider */}
        <Swiper
        spaceBetween={30}
        slidesPerView={2}
        grabCursor={true}
        className='portfolio-slider'
        >
           <SwiperSlide >
           <a href='https://github.com/Reroar/To-do-list' target='_blank' rel='noreferrer'>
            <img src={todolist} alt='' />
            </a>
            <span className='project-name'>To-do list</span>
           </SwiperSlide>

           <SwiperSlide>
           <a href='https://reroar-amazon-clone.netlify.app/' target='_blank' rel='noreferrer'>
           <img src={amazonclone} alt='' />
           
           </a>
           <span className='project-name'>Amazon-Clone</span>
            
           </SwiperSlide>

           <SwiperSlide>
           <a href='https://blog-website-h2zi.onrender.com/' target='_blank' rel='noreferrer'>
           <img src={blogsite} alt='' />
           
           </a>
           <span className='project-name' >Blog-Website</span> 
           </SwiperSlide>



        </Swiper>
    </div>
  )
}

export default Portfolio